import Scroll from '../library/Scroll';

function init(parentSelector = null) {
  let scroll = new Scroll();

  // add scrolltop click handler to all "back to top" buttons
  const backToTopButtons = Array.from(document.querySelectorAll(`${parentSelector !== null ? parentSelector + ' ' : ''}.button--backtotop`));
  const smallScreen = (window.innerWidth <= 767) ? true : false;

  if (backToTopButtons) {
    backToTopButtons.map((elem, index) => {
      elem.addEventListener('click', (e) => {
        e.preventDefault();
      	scroll.top(0, 1000);
      });
    });
  }

  // add scrollto click handler to property single gallerylink
  const propertySingleGalleryLink     = document.querySelector('.propertyteaser__gallerylink');
  const propertySingleGalleryElement  = document.querySelector('.propertygallery');

  if (propertySingleGalleryLink) {
    propertySingleGalleryLink.addEventListener('click', (e) => {
      e.preventDefault();

      let scrollOffset = (smallScreen) ? -50 : -120;
      scroll.to(propertySingleGalleryElement, 1000, scrollOffset);
    });
  }

  // add scrollto click handler to property single congtact
  const propertySingleContactLink     = document.querySelector('.button--contact--singleview');
  const propertySingleContactElement  = document.querySelector('.propertyrequestinfo');

  if (propertySingleContactLink) {
    propertySingleContactLink.addEventListener('click', (e) => {
      e.preventDefault();

      let scrollOffset = (smallScreen) ? -50 : -100;
      scroll.to(propertySingleContactElement, 1000, scrollOffset);
    });
  }

}

export default init;



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/modules/Scrollelements.js